import { useCallback, useEffect, useState } from 'react';
import { api, BoError } from './api';

/** Carrega um recurso do backoffice e expõe `reload` para depois de uma gravação. */
export function useLoad<T>(path: string) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const reload = useCallback(async () => {
    // Sem caminho (pesquisa ainda por escrever): nada a carregar.
    if (!path) { setData(null); return; }
    try { setData(await api<T>(path)); setError(null); } catch (e) { setError(e instanceof BoError ? e.message : 'Sem ligação à internet.'); }
  }, [path]);
  useEffect(() => { void reload(); }, [reload]);
  return { data, error, reload };
}

/** Executa uma acção e devolve a mensagem de erro em português (ou null). */
export async function attempt(fn: () => Promise<unknown>): Promise<string | null> {
  try { await fn(); return null; } catch (e) { return e instanceof BoError ? e.message : 'Sem ligação à internet.'; }
}
